import { Image, ImageProps } from "antd";
import { useGetProductImageFile } from "services/image";
import { getImageFullPath } from "utils/image";
import { useMemo, useEffect, useState } from "react";

interface ProductImageProps extends Omit<ImageProps, "src"> {
  imageUrl: string;
  productCode: string;
}

/**
 * Component สำหรับแสดงรูปภาพผลิตภัณฑ์
 * ตรวจสอบ pattern ของ imageUrl:
 * - ถ้ามี pattern {productcode}/xxx.jpg (เช่น p-14/1762658899292.jpg) จะเรียก API useGetProductImageFile
 * - ถ้าไม่ใช่ จะใช้ getImageFullPath แบบปกติ
 */
const ProductImage = ({
  imageUrl,
  productCode,
  ...imageProps
}: ProductImageProps) => {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);
  // ตรวจสอบว่า imageUrl เป็น pattern {productcode}/xxx.jpg หรือไม่
  // Pattern คือ: ไม่ขึ้นต้นด้วย http, มี / ในชื่อไฟล์, และตรงกับ productCode (ถ้ามี)
  const isProductImagePattern = useMemo(() => {
    return imageUrl.startsWith(`${productCode}/`);
    // if (!imageUrl) return false;
    // if (imageUrl.startsWith("http")) return false;

    // // ตรวจสอบว่ามี / ในชื่อไฟล์ (เช่น p-14/1762658899292.jpg)
    // if (!imageUrl.includes("/")) return false;

    // // ถ้ามี productCode ให้เช็คด้วยว่า imageUrl ขึ้นต้นด้วย productCode หรือไม่

    // return false;
  }, [imageUrl, productCode]);
  const { imageBlob, isLoading } = useGetProductImageFile(
    imageUrl,
    isProductImagePattern
  );
  // สร้าง object URL จาก blob
  useEffect(() => {
    if (imageBlob && isProductImagePattern) {
      const url = URL.createObjectURL(imageBlob);
      setObjectUrl(url);

      // Cleanup object URL เมื่อ component unmount หรือ blob เปลี่ยน
      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [imageBlob, isProductImagePattern]);

  // กำหนด src ตามเงื่อนไข
  const imageSrc = useMemo(() => {
    if (isProductImagePattern) {
      // ถ้าเป็น product image pattern และกำลัง loading หรือยังไม่มี objectUrl
      if (isLoading || !objectUrl) {
        return undefined; // แสดง loading หรือ fallback
      }
      return objectUrl;
    } else {
      // ใช้ getImageFullPath แบบปกติ
      return getImageFullPath(imageUrl);
    }
  }, [isProductImagePattern, isLoading, objectUrl, imageUrl]);

  return (
    <Image
      {...imageProps}
      src={imageSrc}
      loading={isLoading ? "lazy" : undefined}
    />
  );
};

export default ProductImage;
